import React, { useContext, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { faFaceSmile, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import AuthContext from '../contexts/AuthContext';
import { buttonBackground } from '../styles/colors';
import AccountMenu from './account/Menu';
import Navigation from './Navigation';
import ErrorBoundary from './ErrorBoundary';
import Routes from '../routes';

const Screen = styled.div`
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const UserMenuAndContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 32px;
`;

const UserMenu = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-bottom: 16px;
  align-items: center;
`;

const Icon = styled(FontAwesomeIcon)`
  margin-right: 36px;
  font-weight: 500;
  font-size: 1.4rem;
  color: ${buttonBackground};
`;

const Content = styled.div`
  flex: 1;
  margin-top: 16px;
  margin-left: 32px;
`;

const Footer = styled.div`
  border-top: 1px solid  ${buttonBackground};
  padding-top: 16px;
  text-align: right;
`;

const Main = () => {
  const { apolloClient } = useContext(AuthContext);
  const [showAccountMenu, setShowAccountMenu] = useState(false);

  return (
    <BrowserRouter>
      <ApolloProvider client={apolloClient}>
        <Helmet titleTemplate="Fly Louie | %s" defaultTitle="Fly Louie">
          <meta charSet="utf-8" />
        </Helmet>
        <Screen>
          <Navigation />
          <UserMenuAndContent>
            <UserMenu>
              <Icon
                icon={faChevronDown}
                style={{fontSize: '0.8rem', marginRight: 0, cursor: 'pointer'}}
                onClick={() => setShowAccountMenu(!showAccountMenu)}
              />
            </UserMenu>
            {showAccountMenu && (
              <AccountMenu hide={() => setShowAccountMenu(false)} />
            )}

            <Content>
              <ErrorBoundary>
                <Routes />
              </ErrorBoundary>
            </Content>

            <Footer>
              Copyright Fly Louie©2022
            </Footer>
          </UserMenuAndContent>
        </Screen>
      </ApolloProvider>
    </BrowserRouter>
  );
};

export default Main;
